export default "__VITE_ASSET__54e92c36__"